/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var Components = __importStar(require("./index"));

var base = {
  base: {
    backgroundColor: '#fff',
    fontSize: 16
  },
  breakpoints: {
    mobile: 991,
    tablet: 1200
  },
  colors: {
    primary: '#1792e4',
    secondary: '#021d71',
    accent: '#fc7a24',
    text: '#000'
  },
  defaults: {
    Check: {},
    Radio: {}
  },
  select: {
    placeholder: {}
  }
};
var theme = Object.assign({}, base);
exports.theme = theme;
Object.keys(Components).forEach(function (c) {
  return theme[c] = {};
});
theme.Body = {
  maxWidth: 1200
};
theme.Header = {
  height: 110
};
theme.Footer = {
  height: 110
};
theme.Render = {
  height: 500,
  width: 750
};